import { render, staticRenderFns } from "./KBDrugsList.vue?vue&type=template&id=efd63878&scoped=true&"
import script from "./KBDrugsList.vue?vue&type=script&lang=js&"
export * from "./KBDrugsList.vue?vue&type=script&lang=js&"
import style0 from "./KBDrugsList.vue?vue&type=style&index=0&id=efd63878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd63878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VCol,VCombobox,VIcon,VRow,VSelect,VSimpleTable})
